import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../_actions/dataActions";
import * as searchActions from "../../../../_actions/searchActions";
import FilterWidget from "../../../UI/FilterWidget";
import Slider from "../../../UI/Slider";
import Select from "../../../UI/Select";
import Wrapper from "../../../../_hoc/Wrapper";
import getMaritalStatus from "../../../../_selectors/dataSelectors/getMaritalStatus";
import getMotherTongue from "../../../../_selectors/dataSelectors/getMotherTongue";
import getReligion from "../../../../_selectors/dataSelectors/getReligion";
import getMyGender from "../../../../_selectors/userSelectors/getMyGender";
import Input from "../../../UI/Input";
import {lowerCase} from 'lodash';
class Filter extends Component {
  state = {
    name:'',
    showFilter: true,
    ageStart: 24,
    ageEnd: 27,
    selectedMaritalStatus: [],
    selectedMotherTongue: [],
    selectedReligion: []
  };
  componentDidMount() {
    const {
      maritalStatus,
      getMaritalStatusData,
      motherTongue,
      getMotherTongueData,
      religion,
      getReligionData
    } = this.props;

    if (maritalStatus.length === 0) {
      getMaritalStatusData();
    }
    if (motherTongue.length === 0) {
      getMotherTongueData();
    }
    if (religion.length === 0) {
      getReligionData();
    }
  }
  toggleShowFilter = () => {
    this.setState(prevState => ({ showFilter: !prevState.showFilter }));
  };
  search = () => {
    const {
      ageEnd,
      ageStart,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedReligion,
      name
    } = this.state;
    const { search, isFemale } = this.props;
    search({
      data: {
        ageEnd,
        ageStart,
        name:lowerCase(name)
      }
    });
    this.toggleShowFilter();
  };
  render() {
    const {
      showFilter,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedReligion,
      ageEnd,
      ageStart,
      name
    } = this.state;
    const { maritalStatus, motherTongue, religion } = this.props;
    return (
      <FilterWidget
        show={showFilter}
        onToggle={this.toggleShowFilter}
        onSearch={this.search}
       />
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  maritalStatus: getMaritalStatus(state),
  motherTongue: getMotherTongue(state),
  religion: getReligion(state),
  isFemale: getMyGender(state)
});
const mapDispatchToProps = dispatch => ({
  getMaritalStatusData: () => dispatch(dataActions.getMaritalStatus()),
  getMotherTongueData: () => dispatch(dataActions.getMotherTongue()),
  getReligionData: () => dispatch(dataActions.getReligion()),
  search: payload => dispatch(searchActions.search(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter);



// WEBPACK FOOTER //
// ./src/_components/Search/Home/Filter/index.js